// extracted by mini-css-extract-plugin
export default {"wrapper":"ELNTFs0TyFB0bSmD3wuk","submitBtn":"jDLr9Chy7aHxwv6IH29O"};